import { SettingsRowListCombinedProps } from './types';

const usePresenter = (props: SettingsRowListCombinedProps): SettingsRowListCombinedProps => {
  return props;
};

export default usePresenter;
